import * as Yup from "yup"

export const EditViolationSchema = (t: any) => Yup.object().shape({
  reason: Yup.string().required(t("violation.reason_is_required", "Reason is required")),
  explaination: Yup.string()
    .required(t("violation.other_explanation_is_required", "Other/explanation is mandatory"))
    .max(3000, t("violation.other_explanation_must_not_exceed_3000", "Other/explanation must not exceed 3000 characters"))
})

export const EditAdminViolationSchema = (t: any) => Yup.object().shape({
  feedback: Yup.string()
    .required(t("violation.action_plan_is_required", "Action plan is required"))
    .max(3000, t("violation.other_explanation_must_not_exceed_3000", "Other/explanation must not exceed 3000 characters"))
})

export const ViolationSettingSchema = (t: any) =>
  Yup.object().shape({
    emails: Yup.array()
      .min(1, t("global.email_is_required", "Violation email is required"))
      .required(),
  })


